import { CloseIconComponent } from '../icons/close-icon.component';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, inject } from '@angular/core';
import { ProductService } from '../../service/product.service';
import { StringInfoData } from '../../models/string-info';
import {
  ChartOptions,
  NoxChartDta,
  NoxChartXY,
  NoxStringInfoData,
} from '../../models/nox-chart';
import { DateUtils } from '../../utils/date_utils';
import { ApexAxisChartSeries, NgApexchartsModule } from 'ng-apexcharts';
import { CommonModule } from '@angular/common';
import { InverterType, StatsData } from '../../models/stats';
import { PlantDetail } from '../../models/plant';
import { TranslateModule } from '@ngx-translate/core';
import { CspNonceService } from '../../service/csp-nonce.service';
import moment from 'moment';
import { Subject, takeUntil } from 'rxjs';
import { ClickableDirective } from '../../directives/clickable.directive';
import { StringDetailsResponse } from '../../models/stringDetails';
import { gtiHeaderKeys,headerKeys,StringInfoType } from '../../models/enum';
import { StringMetricsResponse } from '../../models/string-graph-details';
@Component({
  selector: 'app-string-info',
  imports: [
    NgApexchartsModule,
    CommonModule,
    TranslateModule,
    CloseIconComponent,
    ClickableDirective
  ],
  templateUrl: './string-info.component.html',
  styleUrl: './string-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StringInfoComponent implements OnDestroy {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly destroy$ = new Subject<void>();
  prodService = inject(ProductService);
  stringInfoData?: StringInfoData;
  noxStringInfoData?: NoxStringInfoData;
  noxChartData: NoxChartDta[] = [];
  noxChartXY: NoxChartXY[] = [];
  series: ApexAxisChartSeries = [];

  chartOptions: Partial<ChartOptions> = {
    legend: { show: false }
  };

  selectedTab: StringInfoType = StringInfoType.VOLTAGE;
  stringInfoType = StringInfoType;

  @Input() statsData?: StatsData;
 @Input() plantName?:string;
  selectedPlant?: PlantDetail | null;
  isOpen = false;
  productService = inject(ProductService);
  inverterType = InverterType;
  gtiStringTableDetails!: any;
gtiHeaderKeys:string[]=gtiHeaderKeys ;
headerKeys:string[]=headerKeys;
  gtiGraphData: any;
  unit!:string;
  constructor(private readonly cspNonceService: CspNonceService) {
    this.prodService.selectedPlant.pipe(takeUntil(this.destroy$)).subscribe((plant) => {
      this.selectedPlant = plant;
      this.cdr.markForCheck();
    });
  }
  
  /**
   * Select tab option from string info
   * @param tab
   */

  getStringTableDetails() {
    if (this.selectedPlant) {
      this.prodService
        .fetchStringTableDetails(
          this.selectedPlant.id,
          DateUtils.getStartDayTimeStampFromDate(new Date()),
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe((res:StringDetailsResponse) => {

          this.gtiStringTableDetails = res.data;
          this.cdr.markForCheck();
        });
    }
  }
  getStringGraphDetails() {
    if (this.selectedPlant) {
      this.prodService
        .fetchStringGraphDetails(
          this.selectedPlant.id,
          DateUtils.getStartDayTimeStampFromDate(new Date()),
           this.selectedTab
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe((res:StringMetricsResponse) => {
          this.gtiGraphData=res.data;
          this.plotGTIChart();
        });
    }
  }
plotGTIChart(): void {
  let graphData: any[] = [];
  let yAxisLabel: 'Voltage (V)' | 'Current (A)' | 'Power (kW)';
  switch (this.selectedTab) {
    case StringInfoType.VOLTAGE:
      graphData = this.gtiGraphData.voltage;
      yAxisLabel='Voltage (V)';
      this.unit='V';
      break;
 
    case StringInfoType.CURRENT:
      graphData = this.gtiGraphData.current;
       yAxisLabel='Current (A)';
        this.unit='A';
      break;
 
    case StringInfoType.POWER:
      graphData = this.gtiGraphData.power;
      yAxisLabel='Power (kW)';
       this.unit='kW';
      break;
  }
  this.noxChartData = [];
 
  graphData.forEach((pv: any, index: number) => {
    this.noxChartXY = [];
 
    pv[Object.keys(pv)[0]].forEach((item: any) => {
   
 
      this.noxChartXY.push({
        x: item.time * 1000,
        y: Number(item.value)
      });
    });
 
    this.noxChartData.push({
      name: `PV ${index + 1}`,
      noxXY: this.noxChartXY
    });
  });
 
  this.noxStringInfoData = {
    noxChartData: this.noxChartData,
    yAxisLabel: yAxisLabel
  };
 
  this.plotLineChart(this.noxStringInfoData);
}
  selectTab(tab: StringInfoType) {
     this.selectedTab = tab;
 
  if (this.statsData?.inverterType === InverterType.GTI) {
    this.getStringGraphDetails(); 
  } else {
    switch (tab) {
      case StringInfoType.VOLTAGE:
        this.plotVoltageLineChart();
        break;
      case StringInfoType.CURRENT:
        this.plotCurrentChart();
        break;
      case StringInfoType.POWER:
        this.plotPowerLineChart();
        break;
      default:
        break;
    }}
    this.cdr.markForCheck();
  }

  /**
   * Plot power line chart
   */
  plotPowerLineChart() {
    this.noxChartData = [];
    this.noxChartXY = [];

    if (this.stringInfoData?.power) {
      for (let i = 0; i < this.stringInfoData.power.length; i++) {
        this.noxChartXY = [];

        this.stringInfoData.power[i].instantiatepVPower.forEach((item) => {
          if (item.power && item.time) {
            this.noxChartXY.push({
              x: item.time * 1000, // convert to milliseconds
              y: Number(item.power),
            });
          }
        });
        this.noxChartData.push({
          name: 'PV ' + (i + 1),
          noxXY: this.noxChartXY,
        });
      }
      this.noxStringInfoData = {
        noxChartData: this.noxChartData,
        yAxisLabel: 'Power (kW)',
      };
      this.unit ='kW';
      this.plotLineChart(this.noxStringInfoData);
    }
  }

  /**
   * Plot current line chart
   */
  plotCurrentChart() {
    this.noxChartData = [];
    this.noxChartXY = [];

    if (this.stringInfoData?.current) {
      for (let i = 0; i < this.stringInfoData.current.length; i++) {
        this.noxChartXY = [];
        this.stringInfoData.current[i].instantiatepVCurrent.forEach((item) => {
          this.noxChartXY.push({
            x: item.time * 1000, // convert to milliseconds
            y: Number(item.current),
          });
        });
        this.noxChartData.push({
          name: 'PV ' + (i + 1),
          noxXY: this.noxChartXY,
        });
      }
      this.noxStringInfoData = {
        noxChartData: this.noxChartData,
        yAxisLabel: 'Current (A)',
      };
      this.plotLineChart(this.noxStringInfoData);
        this.unit ='A';
    }
  }

  /**
   * Plot voltage line chart
   */

  plotVoltageLineChart() {
    this.noxChartData = [];
    this.noxChartXY = [];

    if (this.stringInfoData?.voltage) {
      for (let i = 0; i < this.stringInfoData.voltage.length; i++) {
        this.noxChartXY = [];
        this.stringInfoData.voltage[i].instantiatepVVoltage.forEach((item) => {
          this.noxChartXY.push({
            x: item.time * 1000, // convert to milliseconds
            y: Number(item.voltage),
          });
        });
        this.noxChartData.push({
          name: 'PV ' + (i + 1),
          noxXY: this.noxChartXY,
        });
      }
      this.noxStringInfoData = {
        noxChartData: this.noxChartData,
        yAxisLabel: 'Voltage (V)',
      };

      this.plotLineChart(this.noxStringInfoData);
        this.unit ='V';
    }
  }

  /**
   * Get string trends from API
   */

  getStringTrends() {
    if (this.selectedPlant) {
      this.prodService
        .getStringDetail(
          this.selectedPlant.id,
          DateUtils.getStartDayTimeStampFromDate(new Date()),
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe((res) => {
          this.stringInfoData = res?.data;
          this.plotVoltageLineChart();
          this.cdr.markForCheck();
        });
    }
  }

  /**
   * Plot line chart
   * @param data
   */
  plotLineChart(data: NoxStringInfoData) {
    this.series = data.noxChartData.map((item) => {
      return {
        name: item.name,
        data: item.noxXY.map((item) => {
          return {
            x: item.x,
            y: item.y,
          };
        }),
      };
    });
    const nonce = this.cspNonceService.getNonce() ?? undefined;
    this.chartOptions = {
      chart: {
        type: 'area',
        nonce: nonce,
        height: 280,
        toolbar: {
          show: true,
          tools: {
            pan: true,
          },
          autoSelected: 'pan',
          export: {
            csv: {
              dateFormatter(timestamp: any) {
                return moment(timestamp).format('YYYY-MM-DD HH:mm:ss a');
              },
            } as any,
          },
        },
      },
      grid: {
        padding: {
          top: 5,
        },
      },
      legend: {
        show: true,
        position: 'bottom',
        itemMargin: {
          vertical: 8,
        },
        labels: {
          useSeriesColors: true
        },
      },
      series: this.series,
      stroke: {
        width: 2,
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
      },
      colors:
    this.statsData?.inverterType === InverterType.GTI
      ? [
          '#0086EE','#B191FE','#F395C3','#7FCDAE',
          '#FA925B','#27F346','#FFE101','#C815EC',
          '#FA5778','#EED995','#AAA4B3','#9B52A4',
          '#284940','#B2CDFF','#BD63C9','#C38690',
          '#8AA4B8','#BAAAE1','#F395C3','#839DBA',
          '#DBB5A0','#93B6CC','#F3ECB7','#B3A5A6',
          '#DC8496','#F7E096','#DDCFF6','#877889',
          '#72CAB2','#4A4B4F','#E2A5EA','#D69DA7'
        ]
      : undefined,
 
  
  
      xaxis: {
        type: 'datetime',
        tickAmount: 8,
        labels: {
          datetimeUTC: false,
          formatter: function (value, timestamp: number) {
            return DateUtils.formatTimeFromLocalEpoch(timestamp);
          },
        },
        title: {
          offsetY: 5,
          text: 'Time (hh:mm)',
        },
      },
      yaxis: {
        title: {
          text: this.noxStringInfoData?.yAxisLabel ?? '',
        },
        labels: {
           formatter: (value: number) => value?.toFixed(2),
        },
      },
      tooltip: {
        y: {
          formatter: (value: number) =>
          `${value?.toFixed(2)} ${this.unit}`,
        },
        
      },
    };
    this.cdr.markForCheck();
  }
  /**
   * switch side sheet
   */
  toggle(): void {
    this.isOpen = !this.isOpen;
    this.cdr.markForCheck();
    if (this.isOpen) {
      this.selectedTab = StringInfoType.VOLTAGE;
      if (this.statsData?.inverterType === InverterType.GTI) {
        this.getStringTableDetails();
        this.getStringGraphDetails();
      } else {
        this.getStringTrends();
      }

    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
